import { InMemoryCache, NormalizedCacheObject } from 'apollo-cache-inmemory'
import { ApolloClient } from 'apollo-client'
import { ApolloLink, split } from 'apollo-link'
import { setContext } from 'apollo-link-context'
import { onError } from 'apollo-link-error'
import { WebSocketLink } from 'apollo-link-ws'
import { createUploadLink } from 'apollo-upload-client'
import { getMainDefinition } from 'apollo-utilities'
import { AppOptions } from '../AppOptions'

export function createApolloClient(
  serverAddress: string,
  wsServerAddress?: string | null
): { client: ApolloClient<NormalizedCacheObject> } {
  const enableWebSocket = !!wsServerAddress
  const wsLink = enableWebSocket
    ? new WebSocketLink({
        uri: `${wsServerAddress}/graphql`,
        options: {
          reconnect: true,
        },
      })
    : null

  const httpLink = createUploadLink({
    uri: `${serverAddress}/graphql`,
    credentials: 'include',
  })

  const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = localStorage.getItem(AppOptions.LOCAL_STORAGE_KEY_TOKEN)
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        'X-Auth-From': 'web',
        token: token || '',
      },
    }
  })

  const link = !enableWebSocket
    ? authLink.concat(httpLink)
    : split(
        // split based on operation type
        ({ query }) => {
          // @ts-ignore
          const { kind, operation } = getMainDefinition(query)
          return kind === 'OperationDefinition' && operation === 'subscription'
        },
        // @ts-ignore
        wsLink,
        authLink.concat(httpLink)
      )

  const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
    link: ApolloLink.from([
      onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
          graphQLErrors.map(({ message, locations, path }) =>
            // tslint:disable-next-line:no-console
            console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
          )
        }

        if (networkError) {
          // tslint:disable-next-line:no-console
          console.log(`[Network error]: ${networkError}`)
        }
      }),
      link,
    ]),
    cache: new InMemoryCache(),
    // 우선 캐시는 모두 disable 하도록 한다. 상당히 신경써서 처리하지 않으면 리프레시가 동작하지 않는다.
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'network-only',
        errorPolicy: 'ignore',
      },
      query: {
        fetchPolicy: 'network-only',
        errorPolicy: 'all',
      },
    },
  })

  return { client }
}
